import {scheduleReconnect} from './scheduleReconnect';
import {NORMAL_CLOSE_CODE} from './subscriptionConstants';
import type {SocketContext, SubscriptionState} from './subscriptionTypes';

/**
 * Fired when the socket closes — by the server, by the network, or by us via
 * `close()`. Normal closes (code 1000) and closes during teardown are ignored;
 * everything else means "transport drop, schedule a reconnect".
 */
export const handleSocketClose = (
  event: CloseEvent,
  state: SubscriptionState,
  ctx: SocketContext
) => {
  clearTimeout(ctx.keepAliveTimeout);
  if (state.isCleaningUp || event.code === NORMAL_CLOSE_CODE) {
    return;
  }
  scheduleReconnect(state);
};
